var moduleMap = {
	"./config": () => {
		return Promise.all([__webpack_require__.e(635), __webpack_require__.e(416), __webpack_require__.e(439), __webpack_require__.e(460), __webpack_require__.e(860), __webpack_require__.e(615), __webpack_require__.e(914), __webpack_require__.e(311), __webpack_require__.e(621), __webpack_require__.e(138)]).then(() => (() => ((__webpack_require__(6138)))));
	},
	"./register": () => {
		return Promise.all([__webpack_require__.e(311), __webpack_require__.e(570)]).then(() => (() => ((__webpack_require__(2570)))));
	},
	"./components": () => {
		return Promise.all([__webpack_require__.e(416), __webpack_require__.e(439), __webpack_require__.e(53), __webpack_require__.e(860), __webpack_require__.e(615), __webpack_require__.e(776), __webpack_require__.e(246)]).then(() => (() => ((__webpack_require__(2246)))));
	},
	"./constants": () => {
		return __webpack_require__.e(873).then(() => (() => ((__webpack_require__(1873)))));
	},
	"./hooks": () => {
		return Promise.all([__webpack_require__.e(416), __webpack_require__.e(439), __webpack_require__.e(460), __webpack_require__.e(860), __webpack_require__.e(914), __webpack_require__.e(992)]).then(() => (() => ((__webpack_require__(7992)))));
	},
	"./sagas": () => {
		return Promise.all([__webpack_require__.e(439), __webpack_require__.e(460), __webpack_require__.e(944)]).then(() => (() => ((__webpack_require__(3944)))));
	},
	"./styles": () => {
		return __webpack_require__.e(227).then(() => (() => ((__webpack_require__(4227)))));
	},
	"./types": () => {
		return __webpack_require__.e(826).then(() => (() => ((__webpack_require__(8826)))));
	},
	"./utils": () => {
		return Promise.all([__webpack_require__.e(439), __webpack_require__.e(257)]).then(() => (() => ((__webpack_require__(6257)))));
	},
	"./authorize": () => {
		return __webpack_require__.e(492).then(() => (() => ((__webpack_require__(3492)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});